import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const DewPointIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBgContainer;

  return (
    <>
      <path
        d="M28.75 18.5C29.4404 18.5 30 17.9404 30 17.25C30 16.5596 28.75 14.75 28.75 14.75C28.75 14.75 27.5 16.5596 27.5 17.25C27.5 17.9404 28.0596 18.5 28.75 18.5Z"
        fill={currentColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 15C21 14.4696 21.2107 13.9609 21.5858 13.5858C21.9609 13.2107 22.4696 13 23 13C23.5304 13 24.0391 13.2107 24.4142 13.5858C24.7893 13.9609 25 14.4696 25 15V20.625C25.6115 21.0508 26.0711 21.6606 26.312 22.3657C26.5529 23.0708 26.5625 23.8344 26.3394 24.5454C26.1163 25.2563 25.672 25.8775 25.0714 26.3185C24.4708 26.7595 23.7451 26.9973 23 26.9973C22.2549 26.9973 21.5292 26.7595 20.9286 26.3185C20.328 25.8775 19.8837 25.2563 19.6606 24.5454C19.4375 23.8344 19.4471 23.0708 19.688 22.3657C19.9289 21.6606 20.3885 21.0508 21 20.625V15ZM23 17C23.2761 17 23.5 17.2239 23.5 17.5V21.563C24.3626 21.785 25 22.5681 25 23.5C25 24.6046 24.1046 25.5 23 25.5C21.8954 25.5 21 24.6046 21 23.5C21 22.5681 21.6374 21.785 22.5 21.563V17.5C22.5 17.2239 22.7239 17 23 17ZM23 22.5C22.4477 22.5 22 22.9477 22 23.5C22 24.0523 22.4477 24.5 23 24.5C23.5523 24.5 24 24.0523 24 23.5C24 22.9477 23.5523 22.5 23 22.5Z"
        fill={currentColor}
      />
    </>
  );
};

export default DewPointIcon;
